import React, { useCallback, useEffect, useState } from 'react'
import { Route, Switch, withRouter } from 'react-router-dom'
import classnames from 'classnames'
import message from 'antd/lib/message'
import { ToastContainer } from 'react-toastify'

import { BreakpointsProvider } from 'contexts/BreakpointsContext'
import { DevicesProvider } from 'contexts/DevicesContext'
import { LayoutProvider } from 'contexts/LayoutContext'
import { AppProvider } from 'contexts/AppContext'
import { useCustomerSupportUIManager } from 'contexts/CustomerSupportContext'
import { APP_CONTAINER } from 'helpers/constants'
import Routes from './routes'

import AppChecks from 'components/AppChecks'

import 'react-toastify/dist/ReactToastify.css'
import cls from '../App.module.scss'

const allowVerticalScrollStyle = {
  minHeight: '100%',
}

const App = ({ location }) => {
  useCustomerSupportUIManager()
  const [isMobile, setIsMobile] = useState(false)

  const isCheckingOutPublicEventPage = useCallback(pathname => {
    return pathname.slice(0, 8) === '/events/' && pathname.length > 8
  }, [])

  const isCheckingOutLandingPage = pathname => {
    return pathname === '/'
  }

  const isCheckingOutEventPageAndLoggedIn = pathname => {
    return pathname.slice(0, 8) === '/events/' && pathname.length > 8
  }

  const pageAllowedToScrollVertically = pathname => {
    return (
      isCheckingOutLandingPage(pathname) ||
      isCheckingOutPublicEventPage(pathname) ||
      isCheckingOutEventPageAndLoggedIn(pathname)
    )
  }

  useEffect(() => {
    setIsMobile(window?.innerWidth <= 450)
    message.config({ maxCount: 1 })
  }, [])

  const key = location.pathname.slice('/')[0]
  return (
    <div
      className={classnames(cls.app, APP_CONTAINER.WIDTH_CLASS)}
      style={
        pageAllowedToScrollVertically(location.pathname.toLowerCase())
          ? isCheckingOutEventPageAndLoggedIn(location.pathname.toLowerCase()) && isMobile
            ? allowVerticalScrollStyle
            : allowVerticalScrollStyle
          : null
      }
    >
      <Switch key={key} location={location}>
        <BreakpointsProvider>
          <DevicesProvider>
            <AppProvider>
              <LayoutProvider>
                <Route path="/">
                  <Routes />
                </Route>
                <AppChecks />
              </LayoutProvider>
            </AppProvider>
          </DevicesProvider>
        </BreakpointsProvider>
      </Switch>
      <ToastContainer limit={1} />
    </div>
  )
}

export default withRouter(App)
